import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import styles from "./ImageCarousel.module.scss";

const ImageCarousel = ({ product }) => {
  const { ImagePath, ProductTitle } = product;

  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const IMAGES = require.context("../../../../../public/product-images", true, /\.jpg$/);

  const getProductImages = () => {
    return IMAGES.keys()
      .filter((file) => file.startsWith(`./${ImagePath}`))
      .map((filePath) => `${process.env.PUBLIC_URL}/product-images${filePath.substring(1)}`);
  };

  const images = getProductImages();

  return (
    <div className={styles.carouselColumn}>
      {images.length > 1 ? (
        <Carousel activeIndex={index} onSelect={handleSelect} className={styles.carousel}>
          {images.map((img) => (
            <Carousel.Item key={img} className={styles.carouselItem}>
              <img height="100%" className="d-block" src={img} alt={ProductTitle} />
            </Carousel.Item>
          ))}
        </Carousel>
      ) : (
        <div className={styles.carouselSingle}>
          <img height="100%" className="d-block" src={images[0]} alt={ProductTitle} />
        </div>
      )}
    </div>
  );
};

export { ImageCarousel };

// const getProductImages = () => {
//   return IMAGES.keys()
//   .filter((file) => file.startsWith(`./viewer/${product.Model}`))
//   .map((filePath) => `${process.env.PUBLIC_URL}/product-images${filePath.substring(1)}`);
// };

// const images = getProductImages();
// console.log(images)
